import { api } from '@api/api2';

export const getComplexes = () => api.v1('get', 'complex/list');

export const getBuildings = () =>
  api.v1('get', 'buildings/get-list-available', {
    per_page: 10000,
  });

export const getApartments = () => api.v1('get', 'apartment/simple-list');
export const getProperties = () => api.v1('get', 'property/simple-list');
